export const team22 = [{
  "year": 2022,
  "CoreTeam": [
    {
      "Position": "Chairperson",
      "Name": "P.V Nippun",
      
      "ImgPath": "chair.png"
    },
    {
      "Position": "Vice Chairperson",
      "Name": "Yasaswini Ganji",
      
      "ImgPath": "vice_chair.png"
    },
    {
      "Position": "Secretary",
      "Name": "Teja Abhinav Reddy",
      
      "ImgPath": "gs.png"
    },
    {
      "Position": "Treasurer",
      "Name": "Avinash Batchu",
      
      "ImgPath": "tresury.png"
    },
    {
      "Position": "Membership Chair",
      "Name": "Bhanusree Eesari",
      
      "ImgPath": "membership.png"
    },
    {
      "Position": "Webmaster",
      "Name": "K. Sharwani",
      
      "ImgPath": "webmaster.png"
    }
  ],
  "TeamHeads": [
    {
      "Position": "Social Media Head",
      "Name": "K. Harshitha",
      
      "ImgPath": "sm.png"
    },
    {
      "Position": "Events & PR Head",
      "Name": "B. Poojitha Reddy",
      
      "ImgPath": "pr.png"
    },
    {
      "Position": "Technical Head",
      "Name": "Vysyaraju Harveni",
      
      "ImgPath": "technical.png"
    },
    {
      "Position": "Design Team Head",
      "Name": "Neelima Gundu",
      
      "ImgPath": "design.png"
    },
    {
      "Position": "Coding Team Head",
      "Name": "Sai Neha Ch",
      
      "ImgPath": "coding.png"
    }
  ],
  "Volunteers": [
  {
    "Name": "Chandana Sree Gudapuri",
    "Mail": "gcsree21@gmail.com",
    "Team": "Design",
    "LinkedIn": "https://www.linkedin.com/in/chandana-sree-gudapuri-302213201"
  },
  {
    "Name": "Sravani Gandla",
    "Mail": "sravanishannu2003@gmail.com",
    "Team": "Design",
    "LinkedIn": "https://www.linkedin.com/in/gandla-sravani-9299ab204"
  },
  {
    "Name": "Sanjana Gunturu",
    "Mail": "sanjanagunturu@gmail.com",
    "Team": "Design",
    "LinkedIn": "https://www.linkedin.com/in/sanjana-gunturu-b53748203"
  },
  {
    "Name": "G Manideep Chaitanya Reddy",
    "Mail": "manideepchaitanya7007@gmail.com",
    "Team": "Design",
    "LinkedIn": "https://www.linkedin.com/in/manideep-chaitanya-923435215"
  },
   {
    "Name": "Sri Varshitha Balthu",
    "Mail": "srivarshitha1010@gmail.com",
    "Team": "Design",
    "LinkedIn": "https://www.linkedin.com/in/sri-varshitha-a64882215"
  },
  {
    "Name": "Shravani Garine",
    "Mail": "garineshravani27@gmail.com",
    "Team": "Events & PR and Social Media",
    "LinkedIn": "https://www.linkedin.com/in/garine-shravani-398120215"
  },
  {
    "Name": "Vaishnavi Gundlapally",
    "Mail": "vaishnavigundlapally9@gmail.com",
    "Team": "Events & PR",
    "LinkedIn": "https://www.linkedin.com/in/vaishnavi-gundlapally-171aa8214/"
  },
   {
    "Name": "Samhith Reddy Kosana",
    "Mail": "samhithreddy287@gmail.com",
    "Team": "Events & PR",
    "LinkedIn": "https://www.linkedin.com/in/samhith-reddy-kosana-5bb173205"
  },
  {
    "Name": "Sahithi Penthala",
    "Mail": "penthala.sahithi@gmail.com",
    "Team": "Events & PR",
    "LinkedIn": "https://www.linkedin.com/in/sahithi-penthala-639166215/"
  },
 
  {
    "Name": "Ram Reddy",
    "Mail": "revanthram2829@gmail.com",
    "Team": "Technical",
    "LinkedIn": "https://www.linkedin.com/in/ram-revanth-a59961215"
  },
  {
    "Name": "Sai Charan",
    "Mail": "charanpasupunooti137@gmail.com",
    "Team": "Technical",
    "LinkedIn": "https://www.linkedin.com/in/sai-charan-a6a969201"
  },
  {
    "Name": "Akhil KVK",
    "Mail": "kvkakhil@gmail.com",
    "Team": "Technical",
    "LinkedIn": "https://www.linkedin.com/mwlite/in/akhil-kvk-82981a204"
  },
  {
    "Name": "A V Pavan Reddy",
    "Mail": "pavanreddy2609@gmail.com",
    "Team": "Technical",
    "LinkedIn": "https://www.linkedin.com/in/adi-venkata-pavan-reddy-894407216/"
  },
  {
    "Name": "Sai Charan Metla",
    "Mail": "20071a12f3@vnrvjiet.in",
    "Team": "Technical",
    "LinkedIn": "https://www.linkedin.com/in/sai-charan-9a5b09215"
  },
  {
    "Name": "Abhishek Atyam",
    "Mail": "atyamabhi@gmail.com",
    "Team": "Technical and Events & PR",
    "LinkedIn": "https://www.linkedin.com/in/abhishek-atyam-027406216/"
  },
  {
    "Name": "Avighna Gandra",
    "Mail": "20071a1215@vnrvjiet.in",
    "Team": "Technical and Design",
    "LinkedIn": "http://www.linkedin.com/in/avighna-gandra-654b34204"
  },
 
  {
    "Name": "Naga Sai Nithin Kristam",
    "Mail": "20071a1288@vnrvjiet.in",
    "Team": "Events & PR",
    "LinkedIn": "https://www.linkedin.com/in/kristam-naga-sai-nithin-012a94215/"
  },
  {
    "Name": "Dhanush Gummadavalli",
    "Mail": "dhanushg25@gmail.com",
    "Team": "Social Media",
    "LinkedIn": "https://www.linkedin.com/in/dhanush-g-6923421b9"
  },
  {
    "Name": "Akshitha Mashetty",
    "Mail": "mashettyakshitha@gmail.com",
    "Team": "Social Media",
    "LinkedIn": "https://www.linkedin.com/in/akshitha-mashetty-32a874215"
  },
  {
    "Name": "Sai Vamshi Kola",
    "Mail": "saivamshikola@gmail.com",
    "Team": "Social Media",
    "LinkedIn": "https://www.linkedin.com/in/kola-sai-vamshi-859405216"
  },
  
]

}
]